/* eslint-disable consistent-return */
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { LenderEnum } from "models/inventory/enums/vehicle.enums";
import { VehiclesFilters } from "models/inventory/interfaces/vehicle.interface";
import { SkuFilters } from "models/inventory/interfaces/sku.interface";
import { GET_VEHICLES } from "queries/getVehicles";
import { GET_SKUS } from "queries/getSkus";

export const client = new ApolloClient({
  uri: `${process.env.REACT_APP_API_BASE_URL_PA}graphql`,
  cache: new InMemoryCache(),
});

export const fetchVehiclesGraphql = async (filters: Partial<VehiclesFilters>) => {
  const { data } = await client.query({
    query: GET_VEHICLES,
    variables: {
      status: "available",
      ...filters
    }
  });
  return data;
};

export const fetchBodegaVehiclesGraphql = async (filters: Partial<VehiclesFilters>) => {
  const { data } = await client.query({
    query: GET_VEHICLES,
    variables: {
      ...filters,
      status: "available",
      lenders: [],
    }
  });
  return data;
};

export const fetchSkusGraphql = async (filters: Partial<SkuFilters>) => {
  const { data } = await client.query({
    query: GET_SKUS,
    variables: filters,
  });
  return data;
};
